import { createContext } from 'react';

const UserSessionContext = createContext(
                                        { 
                                          uuid_tenant: '',
                                          session_info: { 
                                              uuid_current_project: '',
                                              uuid_current_opt_campaign: '',
                                              on_create_campaign: {uuid_experimental_setup: '',
                                                                   uuid_design_space: '',
                                                                   uuid_objective: '',
                                                                   validated_experimental_setup: false,
                                                                   validated_design_space: false,
                                                                   validated_objective: false},
                                              on_update_campaign: {uuid_experimental_setup: '',
                                                                   uuid_design_space: '',
                                                                   uuid_objective: '',
                                                                   validated_experimental_setup: false,
                                                                   validated_design_space: false,
                                                                   validated_objective: false}
                                            },
                                        });

                                        
export default UserSessionContext;